import { Link } from 'apollo-react';
import Download from 'apollo-react-icons/Download';
import Plus from 'apollo-react-icons/Plus';
import Trash from 'apollo-react-icons/Trash';
import Button from 'apollo-react/components/Button';
import DateRangePicker from 'apollo-react/components/DateRangePicker';
import Grid from 'apollo-react/components/Grid';
import IconButton from 'apollo-react/components/IconButton';
import Select from 'apollo-react/components/Select';
import Table, { compareStrings } from 'apollo-react/components/Table';
import Tooltip from 'apollo-react/components/Tooltip';
import { format } from 'date-fns';
import { React, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import ConfirmDialog from '../common/ConfirmDialog';
import { API_URL, OBJ_ROLE, STATUS_CODE, SYS_ROLE } from '../common/Constants';
import DetailDialog from '../common/DetailDialog';
import Dialog from '../common/Dialog';
import Loading from '../common/Loading';
import { deleteApi, getApi, getFuncroleFlg, setMessage, setURL, getHeader, MaintenanceApiError, CustomApiError, redirectToLogin } from '../common/Utils';
import fileManagementData from '../json/fileManagementData.json';
import selectItemAuditData from '../json/selectItemAuditData.json';
import selectItemOrgData from '../json/selectItemOrgData.json';
import selectItemProjData from '../json/selectItemProjData.json';
import './FileManagement.scss';
import Checkbox from '@mui/material/Checkbox';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import authData from '../json/authData.json';
import userIdData from '../json/userIdData.json';
import funcroleData from '../json/funcroleData.json';
// SignalR接続用のimportを追加（ファイル上部）
import * as signalR from "@microsoft/signalr";

//レンダリングのタイミングに影響されないように取得権限退避用にグローバル変数を定義
let globalDownloadFileLinkAuthFlg = false;
let globalDeleteFileBtnAuthFlg = false;
let globalAuditCode;
let globalProjCode;
let globalUsrTypeCode;
let globalDownloadList = [];

/**
 * ファイル管理
 */
function FileManagement() {
	const location = useLocation();
	const [t] = useTranslation();
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(true);
	const DIALOG_STATUS = {
		NO_DIALOG: '0',
		OK_DIALOG: '1',
		DETAIL_DIALOG: '2',
		DELETE_CONFIRM_DIALOG: '3',
	};
	const [dialogStatus, setDialogStatus] = useState(DIALOG_STATUS.NO_DIALOG);
	const [dialogOpen, setDialogOpen] = useState(false);
	const [dialogContent, setDialogContent] = useState('');
	const [detailContent, setDetailContent] = useState('');
	const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
	const [confirmDialogContent, setConfirmDialogContent] = useState('');

	// 企業名選択の権限フラグ
	const [orgSelectorAuthFlg, setOrgSelectorAuthFlg] = useState(false);
	// サービス名選択の権限フラグ
	const [serviceSelectorAuthFlg, setServiceSelectorAuthFlg] = useState(false);
	// プロジェクト名選択の権限フラグ
	const [projSelectorAuthFlg, setProjSelectorAuthFlg] = useState(false);
	// アップロード日選択の権限フラグ
	const [deliveryDateRangeAuthFlg, setDeliveryDateRangeAuthFlg] = useState(false);
	// アップロードボタンの権限フラグ
	const [uploadBtnAuthFlg, setUploadBtnAuthFlg] = useState(false);
	// ファイルダウンロードリンクの権限フラグ
	const [downloadFileLinkAuthFlg, setDownloadFileLinkAuthFlg] = useState(false);
	// 削除ボタンの権限フラグ
	const [deleteFileBtnAuthFlg, setDeleteFileBtnAuthFlg] = useState(false);
	// 企業名の選択リスト
	const [orgList, setOrgList] = useState([]);
	// サービス名の選択リスト
	const [serviceList, setServiceList] = useState([]);
	// プロジェクト名の選択リスト
	const [projList, setProjList] = useState([]);
	// アップロードボタンの権限リスト
	const [uploadBtnAuthList, setUploadBtnAuthList] = useState([]);
	// ファイルダウンロードリンクの権限リスト
	const [downloadFileLinkAuthList, setDownloadFileLinkAuthList] = useState([]);
	// 削除ボタンの権限リスト
	const [deleteFileBtnAuthList, setDeleteFileBtnAuthList] = useState([]);
	// 一覧の表示リスト
	const [fileManagementList, setFileManagementList] = useState([]);
	// ファイル名の選択リスト
	const [filteredColumnsList, setfilteredColumnsList] = useState([]);
	// 検索条件で選択している情報
	const [formValues, setFormValues] = useState({
		org: '',
		service: '',
		proj: '',
		startDate: null,
		endDate: null,
		startDateErrFlg: false,
		endDateErrFlg: false,
	});
	// 選択しているデータ
	const [selectedData, setSelectedData] = useState({
		projRateNo: '',
		fileId: '',
	});

	const FileNameCell = ({ row }) => {
		const fileNameCellDisabledCondition = ((!globalDownloadFileLinkAuthFlg) || ((row.projStatus !== STATUS_CODE.STORAGE_COMPLETE) && (row.projStatus !== STATUS_CODE.DELIVERY_STORAGE_COMPLETE)));
		return (
			<Link className="downloadFileLink" disabled={fileNameCellDisabledCondition} onClick={() => handleDownloadClick(row)}>
				<Download fontSize="small" />{row.fileName}
			</Link>
		);
	};

	const DateCell = ({ row }) => {
		const ret = row.entryDate !== null ? format(new Date(row.entryDate), 'yyyy/MM/dd HH:mm') : '';
		return ret;
	};

	const DeleteCell = ({ row }) => {
		const deleteCellDisplayCondition = ((globalDeleteFileBtnAuthFlg) && ((row.projStatus === STATUS_CODE.STORAGE_COMPLETE) || (row.projStatus === STATUS_CODE.DELIVERY_STORAGE_COMPLETE)));
		return (
			<div>
				<Tooltip title={t('delete')} disableFocusListener placement="right">
					<span>
						<IconButton
							className="deleteFileBtn"
							size="small"
							onClick={() => handleDeleteClick(row)}
							style={{ display: deleteCellDisplayCondition ? "block" : "none" }}
						>
							<Trash />
						</IconButton>
					</span>
				</Tooltip>
			</div>
		);
	}

	const isSelected = (row) => {
		//return downloadList.some(item => item.projRateNo === row.projRateNo && item.fileId === row.fileId);
		//レンダリングの影響受けないグローバル変数から取得
		return globalDownloadList.some(item => item.projRateNo === row.projRateNo && item.fileId === row.fileId);
	};


	const [downloadableList, setDownloadableList] = useState([]);

	const CheckboxCell = ({ row }) => {
		const fileNameCellDisabledCondition = !globalDownloadFileLinkAuthFlg || (row.projStatus !== STATUS_CODE.STORAGE_COMPLETE && row.projStatus !== STATUS_CODE.DELIVERY_STORAGE_COMPLETE);

		useEffect(() => {
			if (fileNameCellDisabledCondition === false) {
				setDownloadableList((prevList) => {
					if (!prevList.some(item => item.projRateNo === row.projRateNo && item.fileId === row.fileId)) {
						return [...prevList, row];
					}
					return prevList;
				});
			}
		}, [fileNameCellDisabledCondition, row]);

		return (
			<div>
				<Checkbox
					checked={isSelected(row)}
					onChange={() => handleCheckboxClick(row)}
					disabled={fileNameCellDisabledCondition}
				/>
			</div>
		);
	};

	const columns = [
		{
			header: '',
			accessor: 'checkbox',
			customCell: CheckboxCell,
			width: 40,
		},
		{
			header: t('fileName'),
			accessor: 'fileName',
			customCell: FileNameCell,
			sortFunction: compareStrings,
			width: 220,
		},
		{
			header: t('fileSize'), // 新しいファイルサイズカラム
			accessor: 'fileSize',
			sortFunction: compareStrings,
			width: 100,
		},
		{
			header: t('uploadDate'),
			accessor: 'entryDate',
			customCell: DateCell,
			fixedWidth: true,
			sortFunction: compareStrings,
			width: 160,
		},
		{
			header: t('uploadUser'),
			accessor: 'upUsr',
			sortFunction: compareStrings,
			width: 160,
		},
		{
			header: t('downloadUser'),
			accessor: 'downUsr',
			sortFunction: compareStrings,
			width: 320,
			overflow: 'hidden',
			textOverflow: 'ellipsis',
		},
		{
			header: t('notice'),
			accessor: 'notices',
			sortFunction: compareStrings,
			width: 220,
		},
		{
			header: t('status'),
			accessor: 'statusName',
			sortFunction: compareStrings,
			width: 160,
		},
		{
			header: '',
			accessor: 'delete',
			customCell: DeleteCell,
			width: 40,
		},
	];

	// ユーザー区分を取得
	// let usr_type_code = JSON.parse(localStorage.getItem("usrTypeCode"));
	const [usr_type_code, setUsrTypeCode] = useState(JSON.parse(localStorage.getItem("usrTypeCode")));

	//sftp改修追加

	/**
	 * 企業選択項目取得APIの成功時の処理
	 * @param {array} response 企業選択項目取得APIのレスポンス
	 * @param {string} auditCode サービスコード
	 */
	function selectOrgApiSuccess(response, auditCode) {
		if (location.state !== null && location.state.org !== '') {
			if (response.find(org => org.orgLevel0Code === location.state.org) !== undefined) {
				commonGetProj(location.state.service, location.state.org);
			} else {
				setFormValues({ ...formValues, ...{ org: '', service: location.state.service, proj: '' } });
				location.state = null;
			}
		} else if (response.length === 1) {
			// 企業名の選択肢が1つのみの場合、プロジェクト選択項目取得処理実行
			commonGetProj(auditCode, response[0].orgLevel0Code);
		} else {
			setFormValues({ ...formValues, ...{ org: '', service: auditCode, proj: '' } });
			location.state = null;
		}

		// 企業名選択リストをセット
		setOrgList(response);
	};

	/**
	 * サービス選択項目取得APIの成功時の処理
	 * @param {array} response サービス選択項目取得APIのレスポンス
	 */
	function selectServiceApiSuccess(response) {
		if (location.state !== null && location.state.service !== '') {
			if (response.find(audit => audit.auditCode === location.state.service) !== undefined) {
				commonGetOrg(location.state.service);
			}
		} else if (response.length === 1) {
			// サービス名の選択肢が1つのみの場合、企業選択項目取得処理実行
			commonGetOrg(response[0].auditCode);
		}

		// サービス名選択リストをセット
		setServiceList(response);
	};

	/**
	 * プロジェクト選択項目取得APIの成功時の処理
	 * @param {object} response プロジェクト選択項目取得APIのレスポンス
	 * @param {object} option 選択している企業コード、サービスコードが設定されているオブジェクト
	 */
	function selectProjApiSuccess(response, option) {
		let updObj = {}
		if (location.state !== null && location.state.proj !== '') {
			if (response.proj.find(proj => proj.projCode === location.state.proj) !== undefined) {
				updObj = location.state;
			} else {
				updObj = { org: location.state.org, service: location.state.service, proj: '' }
			}
		} else if (response.proj.length === 1) {
			updObj = { org: option.orgCode, service: option.auditCode, proj: response.proj[0].projCode }
		} else {
			updObj = { org: option.orgCode, service: option.auditCode, proj: '' }
		}
		setFormValues({ ...formValues, ...updObj });
		location.state = null;

		// formValuesはレンダリング後に値が反映されるため、ディープコピーして別の変数に値をセットする
		let currentObj = structuredClone(formValues);
		currentObj = { ...currentObj, ...updObj };
		search(currentObj, { uploadBtnAuthList: response.uploadBtn, downloadFileLinkAuthList: response.downloadFileLink, deleteFileBtnAuthList: response.deleteFileBtn });

		// プロジェクト名選択リストをセット
		setProjList(response.proj);
		// アップロードボタンの権限リストをセット
		setUploadBtnAuthList(response.uploadBtn);
		// ファイルダウンロードリンクの権限リストをセット
		setDownloadFileLinkAuthList(response.downloadFileLink);
		// 削除ボタンの権限リストをセット
		setDeleteFileBtnAuthList(response.deleteFileBtn);
	};

	/**
	 * ダウンロードリスト取得APIの成功時の処理
	 * @param {object} response ダウンロードリスト取得APIのレスポンス
	 */
	function searchApiSuccess(response) {
		setFileManagementList(response);
	};

	/**
	 * アップロード済ファイル削除APIの成功時の処理
	 */
	function deleteApiSuccess() {
		// 検索処理
		search(formValues);

		setDialogStatus(DIALOG_STATUS.OK_DIALOG);
		const message = t('message.1001100');
		setDialogOpen(true);
		setDialogContent(message);
	};

	/**
	 * 選択項目取得処理の失敗時の処理
	 * @param {object} error エラーオブジェクト
	 */
	function selectItemApiError(error) {
		const detailErrorMessage = '選択項目取得処理でエラーが発生しました。\n(An error occurred during the select item process.)';
		commonError(error, detailErrorMessage);

		//認証期限切れの場合は再ログイン
		redirectToLogin();
	};

	/**
	 * ダウンロードリスト取得APIの失敗時の処理
	 * @param {object} error エラーオブジェクト
	 */
	function searchApiError(error) {
		const detailErrorMessage = 'ダウンロードリスト取得処理でエラーが発生しました。\n(An error occurred during the download list acquisition process.)';
		commonError(error, detailErrorMessage);

		//認証期限切れの場合は再ログイン
		redirectToLogin();
	};

	/**
	 * アップロード済ファイル削除APIの失敗時の処理
	 * @param {object} error エラーオブジェクト
	 */
	function deleteApiError(error) {
		const detailErrorMessage = 'アップロード済ファイル削除処理でエラーが発生しました。\n(An error occurred while deleting the uploaded files.)';
		commonError(error, detailErrorMessage);

		//認証期限切れの場合は再ログイン
		redirectToLogin();
	};

	/**
	 * 共通エラー処理
	 * @param {object} error エラーオブジェクト
	 * @param {string} detailErrorMessage 詳細ダイアログに設定するエラーメッセージ
	 */
	const commonError = (error, detailErrorMessage) => {
		if (error.name === 'MaintenanceApiError') {
			navigate('/', { state: { maintenanceFlg: true, } });
		} else if (error.name === 'CustomApiError') {
			const message = error.message;
			setDialogStatus(DIALOG_STATUS.OK_DIALOG);
			setDialogOpen(true);
			setDialogContent(message);
		} else {
			setDialogStatus(DIALOG_STATUS.DETAIL_DIALOG);
			setDialogOpen(true);
			setDialogContent(detailErrorMessage);
			setDetailContent(error.stack);
		}
	};

	/**
	 * クリア処理
	 */
	const clear = () => {
		setUploadBtnAuthFlg(false);
		setDownloadFileLinkAuthFlg(false);
		setDeleteFileBtnAuthFlg(false);
		setUploadBtnAuthList([]);
		setDownloadFileLinkAuthList([]);
		setDeleteFileBtnAuthList([]);
		setFileManagementList([]);
		//グローバル変数初期化
		globalAuditCode = "";
		globalProjCode = "";
		globalUsrTypeCode = "";
		globalDownloadList = [];
	}

	/**
	 * 共通企業選択項目取得処理
	 * @param {string} auditCode サービスコード
	 */
	const commonGetOrg = async (auditCode) => {
		// 組織選択項目取得API
		const url = setURL(API_URL.SELECT_ITEM_ORGLEVEL0) + '?';
		// クエリパラメータ作成
		const params = {};
		params['auditCode'] = auditCode;
		const urlSearchParam = String(new URLSearchParams(params));
		const getApiParam = {
			url: url + urlSearchParam,
			sysRole: SYS_ROLE.FILE_MANAGEMENT,
			success: selectOrgApiSuccess,
			error: selectItemApiError,
			json: selectItemOrgData,
			option: auditCode
		}
		await getApi(getApiParam);
	};

	/**
	 * 企業名の選択ダイアログで選択時の処理
	 * @param {object} event イベント
	 */
	const selectOrg = (event) => {
		clear();
		if (event.target.value === '') {
			const updObj = { org: '', proj: '' };
			setFormValues({ ...formValues, ...updObj });
		} else {
			commonGetProj(formValues.service, event.target.value);
		}
	};

	/**
	 * サービス名の選択ダイアログで選択時の処理
	 * @param {object} event イベント
	 */
	const selectService = (event) => {
		clear();
		if (event.target.value === '') {
			const updObj = { org: '', service: '', proj: '' };
			setFormValues({ ...formValues, ...updObj });
		} else {
			//グローバル変数にセット
			globalAuditCode = event.target.value
			commonGetOrg(event.target.value);
		}
	};

	/**
	 * 共通プロジェクト選択項目取得処理
	 * @param {string} orgCode 企業コード
	 * @param {string} auditCode サービスコード
	 */
	const commonGetProj = async (auditCode, orgCode) => {
		// プロジェクト選択項目取得API
		const url = setURL(API_URL.SELECT_ITEM_PROJ) + '?';
		// クエリパラメータ作成
		const params = {};
		params['orgLevel0Code'] = orgCode;
		params['auditCode'] = auditCode;
		const urlSearchParam = String(new URLSearchParams(params));
		const getApiParam = {
			url: url + urlSearchParam,
			sysRole: SYS_ROLE.FILE_MANAGEMENT,
			success: selectProjApiSuccess,
			error: selectItemApiError,
			json: selectItemProjData,
			option: { orgCode: orgCode, auditCode: auditCode }
		}
		await getApi(getApiParam);
	};

	/**
	 * 選択ダイアログで選択時の処理
	 * @param {object} event イベント
	 */
	const selectProj = (event) => {
		setFileManagementList([]);
		// formValuesはレンダリング後に値が反映されるため、ディープコピーして別の変数に値をセットする
		let currentObj = structuredClone(formValues);

		//グローバル変数にセット
		globalProjCode = event.target.value

		const updObj = { proj: event.target.value }
		setFormValues({ ...formValues, ...updObj });
		currentObj = { ...currentObj, ...updObj };
		search(currentObj);
	};

	/**
	 * アップロード日の選択時の処理
	 * @param {object} event イベント
	 */
	const selectDate = (event) => {
		// formValuesはレンダリング後に値が反映されるため、ディープコピーして別の変数に値をセットする
		let currentObj = structuredClone(formValues);

		let updObj = {};
		if (event[0] !== null) {
			updObj.startDate = event[0]._d;
		} else {
			updObj.startDate = null;
		}
		if (event[1] !== null) {
			updObj.endDate = event[1]._d;
		} else {
			updObj.endDate = null;
		}
		updObj.startDateErrFlg = updObj.startDate === null ? false : isNaN(updObj.startDate.getDate());
		updObj.endDateErrFlg = updObj.endDate === null ? false : isNaN(updObj.endDate.getDate());
		setFormValues({ ...formValues, ...updObj });
		currentObj = { ...currentObj, ...updObj };
		search(currentObj);
	};

	/**
	 * 検索処理
	 * @param {object} currentObj 検索条件で選択している情報
	 * @param {object} authObj 権限のオブジェクト
	 */
	const search = async (currentObj, authObj = { uploadBtnAuthList: uploadBtnAuthList, downloadFileLinkAuthList: downloadFileLinkAuthList, deleteFileBtnAuthList: deleteFileBtnAuthList }) => {
		if (currentObj.service && currentObj.org && currentObj.proj) {
			// アップロードボタンの権限フラグを設定
			setUploadBtnAuthFlg(authObj.uploadBtnAuthList.find(uploadBtnAuth => uploadBtnAuth.orgLevel0Code === currentObj.org && uploadBtnAuth.auditCode === currentObj.service && uploadBtnAuth.projCode === currentObj.proj) !== undefined);
		}
		if (currentObj.service && currentObj.org && currentObj.proj && !currentObj.startDateErrFlg && !currentObj.endDateErrFlg) {
			// ファイルダウンロードリンクの権限フラグを設定
			const downloadAuthFlag = authObj.downloadFileLinkAuthList.find(
				downloadFileLinkAuth => downloadFileLinkAuth.orgLevel0Code === currentObj.org &&
					downloadFileLinkAuth.auditCode === currentObj.service &&
					downloadFileLinkAuth.projCode === currentObj.proj
			) !== undefined;
			setDownloadFileLinkAuthFlg(downloadAuthFlag);
			//グローバル変数に退避
			globalDownloadFileLinkAuthFlg = downloadAuthFlag;

			// 削除ボタンの権限フラグを設定
			const deleteAuthFlag = authObj.deleteFileBtnAuthList.find(
				deleteFileBtnAuth => deleteFileBtnAuth.orgLevel0Code === currentObj.org &&
					deleteFileBtnAuth.auditCode === currentObj.service &&
					deleteFileBtnAuth.projCode === currentObj.proj
			) !== undefined
			setDeleteFileBtnAuthFlg(deleteAuthFlag);
			//グローバル変数に退避
			globalDeleteFileBtnAuthFlg = deleteAuthFlag;

			//グローバル変数にセット
			globalAuditCode = currentObj.service;
			globalProjCode = currentObj.proj;

			// ダウンロードリスト取得API
			const url = setURL(API_URL.UPHIST_CLIENT) + '?';

			// クエリパラメータ作成
			const params = {};
			params['orgLevel0Code'] = currentObj.org;
			params['auditCode'] = currentObj.service;
			params['projCode'] = currentObj.proj;
			const option = { year: 'numeric', month: '2-digit', day: '2-digit' };
			if (currentObj.startDate) {
				params['fromDate'] = currentObj.startDate.toLocaleDateString('ja-JP', option).split("/").join("-");
			};
			if (currentObj.endDate) {
				params['toDate'] = currentObj.endDate.toLocaleDateString('ja-JP', option).split("/").join("-");
			};
			const urlSearchParam = String(new URLSearchParams(params));

			const getApiParam = {
				url: url + urlSearchParam,
				sysRole: SYS_ROLE.FILE_MANAGEMENT,
				success: searchApiSuccess,
				error: searchApiError,
				json: fileManagementData
			}
			await getApi(getApiParam);
		} else {
			setFileManagementList([]);
		}
	};

	/**
	 * アップロードボタン押下時の処理
	 */
	const handleUploadClick = () => {
		// 企業名の取得
		const orgName = orgList.find(orgLevel0 => orgLevel0.orgLevel0Code === formValues.org)['comp'];
		// サービス名の取得
		const serviceName = serviceList.find(audit => audit.auditCode === formValues.service)['auditName'];
		// プロジェクト名の取得
		const projName = projList.find(proj => proj.projCode === formValues.proj)['projName'];
		const param = {
			orgCode: formValues.org,
			orgName: orgName,
			serviceCode: formValues.service,
			serviceName: serviceName,
			projCode: formValues.proj,
			projName: projName,
		};
		// アップロード画面へ遷移
		navigate('/upload', { state: param });
	};

	/**
 * ファイルのダウンロード時の処理
 * @param {object} row 選択している行の情報
 */
	const handleDownloadClick = async (row) => {
		try {
			const fileName = row.fileName;
			//console.log(`[DEBUG] Starting download for file: ${fileName}`);
       		//console.log(`[DEBUG] File ID: ${row.fileId}, ProjRateNo: ${row.projRateNo}`);

			const options = { 'suggestedName': fileName };
			const handle = await window.showSaveFilePicker(options);
			const writableStream = await handle.createWritable();
			
			const url = setURL(API_URL.DOWNLOAD) + '/' + row.fileId + '?';
			const params = {};
			params['auditCode'] = globalAuditCode;
			params['projCode'] = globalProjCode;
			params['projRateNo'] = row.projRateNo;
			const urlSearchParam = String(new URLSearchParams(params));
	
			//console.log(`[DEBUG] Download URL: ${url + urlSearchParam}`);  // ← 追加

			let blob;
			if (process.env.NODE_ENV === 'production') {
				// ★★★ 事前に0バイトファイルをチェック ★★★
				//console.log(`[DEBUG] Checking file size for: ${row.fileId}`);  // ← 追加
            	const fileSize = await checkFileSize(row.fileId);
            	//console.log(`[DEBUG] File size detected: ${fileSize} bytes`);  // ← 追加
				
				if (fileSize === 0) {
					// 0バイトファイルの場合は直接空のBlobを作成
					//console.log('[INFO] Handling 0-byte file directly');
					showProgressBar();
					updateProgress(100);
					blob = new Blob([], { type: 'application/octet-stream' });
				} else if (fileSize > 0) {
					// 通常のファイルの場合はSFTP処理を実行
					console.log(`[INFO] Starting normal download for ${fileSize} bytes file`);  // ← 追加
					blob = await startDownload(url + urlSearchParam);
				} else {
					// サイズ不明の場合は従来通り処理（フォールバック）
					//console.warn('[WARN] File size unknown, proceeding with normal download');
					blob = await startDownload(url + urlSearchParam);
				}
			} else {
				// 開発環境での処理
				//console.log('[DEBUG] Development mode - simulating download');  // ← 追加
				showProgressBar();
				for (let i = 0; i <= 100; i += 20) {
					updateProgress(i);
					await new Promise(resolve => setTimeout(resolve, 100));
				}
				blob = new Blob([createLargeContent(100)], { type: 'text/csv' });
			}
			
			//console.log(`[DEBUG] Blob created. Size: ${blob.size} bytes, Type: ${blob.type}`);  // ← 追加

			await writableStream.write(blob);
			await writableStream.close();
			
			console.log('[INFO] File download completed successfully');  // ← 追加

			setDialogStatus(DIALOG_STATUS.OK_DIALOG);
			const message = t('message.1000930');
			setDialogOpen(true);
			setDialogContent(message);
	
		} catch (error) {
			console.error(`[ERROR] Download failed:`, error);  // ← 追加
        	console.error(`[ERROR] Error stack:`, error.stack);  // ← 追加

			if (error instanceof DOMException) {
				// ファイル保存ダイアログを閉じただけなので何もしない
				//console.log('[INFO] User cancelled file save dialog');  // ← 追加
			} else {
				const detailErrorMessage = 'ダウンロード処理でエラーが発生しました。\n(An error occurred during the download process.)';
				console.error(`[ERROR] ダウンロード処理でエラーが発生: ${error.message}`);
				commonError(error, detailErrorMessage);
			}
		} finally {
			//console.log('[DEBUG] Hiding progress bar');  // ← 追加
			hideProgressBar();
		}
	};
			
		// 指定したサイズの文字列を生成
	const createLargeContent = (sizeInMB = 10) => {
		const oneMB = 1024 * 1024;
		const targetSize = sizeInMB * oneMB;
		const chunk = 'test,data,sample,content,'.repeat(1000); // 約20KB
		const chunksNeeded = Math.ceil(targetSize / chunk.length);
		return chunk.repeat(chunksNeeded).substring(0, targetSize);
	};

	// JobID検証用のヘルパー関数を追加
	const sanitizeJobId = (jobId) => {
		// null/undefined/空文字チェック
		if (!jobId || typeof jobId !== 'string') {
			return null;
		}
		
		// GUIDフォーマットの検証（一般的なJobIDの形式）
		const guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
		if (!guidPattern.test(jobId)) {
			return null;
		}
		
		// 危険な文字の除去
		const sanitized = jobId.replace(/[^a-zA-Z0-9\-]/g, '');
		
		// 長さ制限（通常のGUIDは36文字）
		if (sanitized.length !== 36) {
			return null;
		}
		
		return sanitized;
	};

	/**
	 * ファイルサイズを事前チェックする関数
	 * @param {string} fileId ファイルID
	 * @returns {Promise<number>} ファイルサイズ（バイト）
	 */
	const checkFileSize = async (fileId) => {
		try {
			const url = setURL(API_URL.FILE_INFO) + '/' + fileId;
			const response = await fetch(url, {
				method: 'HEAD',
				headers: getHeader(SYS_ROLE.FILE_MANAGEMENT).headers
			});
			
			if (!response.ok) {
				throw new Error(`ファイル情報取得に失敗: ${response.status}`);
			}
			
			const contentLength = response.headers.get('Content-Length');
			return parseInt(contentLength || '0');
		} catch (error) {
			//console.warn('[WARN] File size check failed:', error);
			return -1; // サイズ不明の場合
		}
	};

	// 既存の状態変数の後に追加
	const [showProgress, setShowProgress] = useState(false);
	const [showSpinner, setShowSpinner] = useState(false); 
	const [progressValue, setProgressValue] = useState(0);

	// showProgressBar関数を修正
	const showProgressBar = () => {
		setShowSpinner(false);
		setShowProgress(true);
		setProgressValue(0);
	};

	// updateProgress関数を修正
	const updateProgress = (percentage) => {
		setProgressValue(percentage);
	};

	// hideProgressBar関数を追加
	const hideProgressBar = () => {
		setShowProgress(false);
		setShowSpinner(false);
		setProgressValue(0);
	};

	// スピナー表示用の関数を追加
	const showSpinnerBar = () => {
		setShowSpinner(true);
		setShowProgress(false);
	};

	// 既存のstartDownload関数を修正
	async function startDownload(remotePath) {
		return new Promise(async (resolve, reject) => {
			try {
				// SFTP処理開始時にプログレスバーを表示（スピナーではなく）
				showProgressBar();
				updateProgress(0); // 0%から開始
				
				// ① ジョブ開始APIを呼び出して、ジョブIDを取得
				const res = await fetch('/api/start-download', {
					method: 'POST',
					headers: { 
						'Content-Type': 'application/json',
						...getHeader(SYS_ROLE.FILE_MANAGEMENT).headers
					},
					body: JSON.stringify({ remotePath })
				});
				
				if (!res.ok) {
					if (res.status === 409) {
						// 409エラーの場合は0バイトファイルとして処理
						//console.log('[INFO] 409 Conflict detected, treating as 0-byte file');
						return new Blob([], { type: 'application/octet-stream' });
					}
					throw new Error(`ジョブ開始に失敗しました: ${res.status}`);
				}
				const { jobId } = await res.json();
				
				// SignalR接続を確立（自動再接続とエラーハンドリングを追加）
				const connection = new signalR.HubConnectionBuilder()
					.withUrl("/progressHub")
					.withAutomaticReconnect([0, 2000, 10000, 30000]) // 自動再接続
					.configureLogging(signalR.LogLevel.Warning)
					.build();

				// 接続状態の監視を追加
				connection.onreconnecting((error) => {
					console.warn('[WARN] SignalR reconnecting:', error);
				});

				connection.onreconnected((connectionId) => {
					//console.log('[INFO] SignalR reconnected:', connectionId);
					// 再接続時にジョブグループに再参加
					connection.invoke("JoinGroup", jobId).catch(console.error);
				});

				connection.onclose((error) => {
					if (error) {
						console.error('[ERROR] SignalR connection closed:', error);
					} else {
						//console.log('[INFO] SignalR connection closed normally');
					}
				});
				
				// 接続開始時のエラーハンドリング
				try {
					await connection.start();
					//console.log('[INFO] SignalR connection established');
				} catch (error) {
					console.error('[ERROR] SignalR connection failed:', error);
					// SignalR接続失敗時はポーリングのみで継続
				}
				//console.log('[INFO] SignalR connection established');

				// ジョブグループに参加
				await connection.invoke("JoinGroup", jobId);

				// ★★★ ハートビート状態管理変数を追加 ★★★
				let heartbeatFailureCount = 0;
				let lastHeartbeatTime = Date.now();
				const MAX_HEARTBEAT_FAILURES = 3; // 連続失敗許容回数
				const HEARTBEAT_INTERVAL = 30000; // 30秒間隔
				const HEARTBEAT_TIMEOUT = 10000; // 10秒タイムアウト

				// ★★★ ハートビート実行関数を追加 ★★★
				const performHeartbeat = async () => {
					if (connection.state !== signalR.HubConnectionState.Connected) {
						//console.log('[DEBUG] Skipping heartbeat - connection not active');
						return;
					}
				
					try {
						//console.log('[DEBUG] Sending heartbeat using JoinGroup...');
						
						// Pingの代わりにJoinGroupを使用してヘルスチェック
						const heartbeatPromise = connection.invoke("JoinGroup", jobId);
						const timeoutPromise = new Promise((_, reject) => {
							setTimeout(() => reject(new Error('Heartbeat timeout')), HEARTBEAT_TIMEOUT);
						});
						
						// どちらか早い方で解決
						await Promise.race([heartbeatPromise, timeoutPromise]);
						
						// ハートビート成功
						//console.log('[DEBUG] Heartbeat successful using JoinGroup');
						heartbeatFailureCount = 0; // 失敗カウントをリセット
						lastHeartbeatTime = Date.now();
						
					} catch (error) {
						heartbeatFailureCount++;
						console.warn(`[WARN] Heartbeat failed (${heartbeatFailureCount}/${MAX_HEARTBEAT_FAILURES}):`, error.message);
						
						// 連続失敗が許容回数を超えた場合
						if (heartbeatFailureCount >= MAX_HEARTBEAT_FAILURES) {
							console.error('[ERROR] Maximum heartbeat failures reached, attempting reconnection');
							
							try {
								// 強制的に接続を切断して再接続を試行
								await connection.stop();
								//console.log('[INFO] Connection stopped, attempting restart...');
								
								await connection.start();
								//console.log('[INFO] Connection restarted successfully');
								
								// ジョブグループに再参加
								await connection.invoke("JoinGroup", jobId);
								//console.log('[INFO] Rejoined job group after reconnection');
								
								// 失敗カウントをリセット
								heartbeatFailureCount = 0;
								lastHeartbeatTime = Date.now();
								
							} catch (reconnectError) {
								console.error('[ERROR] Failed to reconnect after heartbeat failures:', reconnectError);
								// 再接続に失敗した場合は処理を継続（ポーリングに依存）
							}
						}
					}
				};

				// 1. 定期的な接続状態チェック
				const connectionMonitor = setInterval(() => {
					if (connection.state === signalR.HubConnectionState.Disconnected) {
						console.warn('[WARN] SignalR disconnected, attempting reconnection');
						connection.start()
							.then(() => {
								//console.log('[INFO] SignalR reconnection successful');
								// 再接続後にジョブグループに再参加
								return connection.invoke("JoinGroup", jobId);
							})
							.catch((error) => {
								console.error('[ERROR] SignalR reconnection failed:', error);
							});
					} else if (connection.state === signalR.HubConnectionState.Connecting) {
						//console.log('[INFO] SignalR is connecting...');
					}
				}, 30000);


				// ★★★ 2. ハートビート定期実行（修正版） ★★★
				const heartbeatInterval = setInterval(performHeartbeat, HEARTBEAT_INTERVAL);

				// ★★★ 3. ハートビート健全性チェック（新規追加） ★★★
				const heartbeatHealthCheck = setInterval(() => {
					const timeSinceLastHeartbeat = Date.now() - lastHeartbeatTime;
					
					// 2分間ハートビートが成功していない場合
					if (timeSinceLastHeartbeat > 2 * 60 * 1000) {
						console.warn('[WARN] No successful heartbeat for 2 minutes');
						
						// 接続状態を確認
						if (connection.state === signalR.HubConnectionState.Connected) {
							console.warn('[WARN] Connection appears active but heartbeat is failing');
							// 即座にハートビートを実行
							performHeartbeat();
						}
					}
				}, 60000); // 1分ごとにチェック


				// 3. 接続品質監視（オプション）
				let lastProgressTime = Date.now();
				const connectionQualityMonitor = setInterval(() => {
					const timeSinceLastProgress = Date.now() - lastProgressTime;
					// 5分間プログレス更新がない場合は警告
					if (timeSinceLastProgress > 5 * 60 * 1000) {
						console.warn('[WARN] No progress updates for 5 minutes, connection may be unstable');
					}
				}, 60000); // 1分ごとにチェック

				// ★★★ サーバーからのハートビート応答監視（新規追加） ★★★
				connection.on("Pong", (timestamp) => {
					//console.log('[DEBUG] Received Pong from server:', new Date(timestamp));
					heartbeatFailureCount = 0;
					lastHeartbeatTime = Date.now();
				});

				// ★★★ 接続状態変更時のハートビート処理（新規追加） ★★★
				connection.onreconnected((connectionId) => {
					//console.log('[INFO] SignalR reconnected, resetting heartbeat:', connectionId);
					heartbeatFailureCount = 0;
					lastHeartbeatTime = Date.now();
					// 再接続後すぐにハートビートを実行
					setTimeout(performHeartbeat, 1000);
					// 再接続時にジョブグループに再参加（既存のコードを移動）
					connection.invoke("JoinGroup", jobId).catch(console.error);
				});

				// プログレス更新を監視
				connection.on("ProgressUpdate", (progressData) => {
					// プログレス受信時刻を更新
					lastProgressTime = Date.now();
					
					try {
						switch (progressData.type) {
							case 'sftp_start':
								updateProgress(1);
								break;
							case 'sftp_connected':
								updateProgress(2);
								break;
							case 'sftp_progress':
								const sftpProgress = Math.min(progressData.percentage || 0, 100);
								const mappedProgress = 2 + (sftpProgress * 0.68);
								updateProgress(Math.round(mappedProgress));
								break;
							case 'sftp_completed':
								updateProgress(70);
								break;
							case 'download_ready':  // ← 追加
								updateProgress(72);
								break;
								case 'download_start':
								updateProgress(75);
								break;
							case 'download_completed':
								updateProgress(100);
								break;
							case 'download_error':
							case 'error':
								console.error('[ERROR] Download error via SignalR:', progressData.message);
								// エラー時は全ての監視を停止
								clearInterval(connectionMonitor);
								clearInterval(heartbeatInterval);
								clearInterval(heartbeatHealthCheck); // ★★★ 追加 ★★★
								clearInterval(connectionQualityMonitor);
								clearInterval(interval);
								clearTimeout(timeout);
								connection.stop();
								reject(new Error(progressData.message || 'SignalRエラーが発生しました'));
								break;
						}
					} catch (error) {
						console.error('[ERROR] Progress update handling failed:', error);
					}
				});
				
				// タイムアウト設定（4時間）
				const timeout = setTimeout(async () => {
					// 全ての監視を停止
					clearInterval(connectionMonitor);
					clearInterval(heartbeatInterval);
					clearInterval(heartbeatHealthCheck);
					clearInterval(connectionQualityMonitor);
					
					// タイムアウト時も安全に接続を切断
					try {
						await connection.invoke("LeaveGroup", jobId);
						//console.log('[INFO] Successfully left job group on timeout');
					} catch (leaveError) {
						console.warn('[WARN] Failed to leave group on timeout:', leaveError.message);
					}
					
					setTimeout(async () => {
						try {
							if (connection.state === signalR.HubConnectionState.Connected) {
								await connection.stop();
								//console.log('[INFO] Connection stopped on timeout');
							}
						} catch (stopError) {
							console.warn('[WARN] Error stopping connection on timeout:', stopError.message);
						}
					}, 100);
					
					reject(new Error('ダウンロードがタイムアウトしました'));
				}, 4 * 60 * 60 * 1000);
				
				// ② ポーリングでジョブステータスを定期確認
				const interval = setInterval(async () => {
					try {
						const statusRes = await fetch(`/api/job-status/${jobId}`, {
							headers: getHeader(SYS_ROLE.FILE_MANAGEMENT).headers
						});
						
						if (!statusRes.ok) {
							throw new Error(`ステータス確認に失敗しました: ${statusRes.status}`);
						}
						
						const { status } = await statusRes.json();

						if (status === 'Completed') {
							clearInterval(interval);
							clearInterval(connectionMonitor);
							clearInterval(heartbeatInterval);
							clearInterval(heartbeatHealthCheck);
							clearInterval(connectionQualityMonitor);
							clearTimeout(timeout);
							
							// LeaveGroupを安全に実行
							try {
								await connection.invoke("LeaveGroup", jobId);
								//console.log('[INFO] Successfully left job group');
							} catch (leaveError) {
								console.warn('[WARN] Failed to leave group:', leaveError.message);
							}
							
							// ダウンロードURLを生成して、downloadWithProgressで取得
							const downloadUrl = `/api/download-job/${jobId}`;
							const blob = await downloadWithProgress(downloadUrl);
							
							// 接続を安全に切断（非同期で実行）
							setTimeout(async () => {
								try {
									if (connection.state === signalR.HubConnectionState.Connected) {
										await connection.stop();
										//console.log('[INFO] Connection gracefully stopped');
									}
								} catch (stopError) {
									console.warn('[WARN] Error stopping connection:', stopError.message);
								}
							}, 200);
							
							resolve(blob);
						} else if (status === 'Failed') {
							clearInterval(interval);
							clearInterval(connectionMonitor);
							clearInterval(heartbeatInterval);
							clearInterval(heartbeatHealthCheck);
							clearInterval(connectionQualityMonitor);
							clearTimeout(timeout);
							
							// 失敗時も安全に接続を切断
							try {
								await connection.invoke("LeaveGroup", jobId);
								//console.log('[INFO] Successfully left job group on failure');
							} catch (leaveError) {
								console.warn('[WARN] Failed to leave group on failure:', leaveError.message);
							}
							
							setTimeout(async () => {
								try {
									if (connection.state === signalR.HubConnectionState.Connected) {
										await connection.stop();
										//console.log('[INFO] Connection stopped on failure');
									}
								} catch (stopError) {
									console.warn('[WARN] Error stopping connection on failure:', stopError.message);
								}
							}, 100);
							
							reject(new Error('ダウンロードに失敗しました'));
						}
					} catch (error) {
						clearInterval(interval);
						clearInterval(connectionMonitor);
						clearInterval(heartbeatInterval);
						clearInterval(heartbeatHealthCheck);
						clearInterval(connectionQualityMonitor);
						clearTimeout(timeout);
						
						// エラー時も安全に接続を切断
						try {
							await connection.invoke("LeaveGroup", jobId);
							//console.log('[INFO] Successfully left job group on error');
						} catch (leaveError) {
							console.warn('[WARN] Failed to leave group on error:', leaveError.message);
						}
						
						setTimeout(async () => {
							try {
								if (connection.state === signalR.HubConnectionState.Connected) {
									await connection.stop();
									//console.log('[INFO] Connection stopped on error');
								}
							} catch (stopError) {
								console.warn('[WARN] Error stopping connection on error:', stopError.message);
							}
						}, 100);
						
						reject(error);
					}
					
				}, 3000);
				
			} catch (error) {
				reject(error);
			}
		});
	}
	

	// チャンク分割ダウンロード関数を修正（リトライ機能とチャンクサイズ調整付き）
	const downloadWithChunks = async (url) => {
		try {
			//console.log(`[INFO] Starting chunk download for: ${url}`);
			
			// まずファイルサイズを取得
			const headResponse = await fetch(url, { 
				method: 'HEAD',
				headers: getHeader(SYS_ROLE.FILE_MANAGEMENT).headers
			});
			
			if (!headResponse.ok) {
				throw new Error(`ファイル情報の取得に失敗しました: ${headResponse.status}`);
			}
			
			const contentLengthHeader = headResponse.headers.get('Content-Length');
			const totalSize = parseInt(contentLengthHeader || '0');
			
			if (totalSize === 0) {
				//console.log('[INFO] 0-byte file detected, returning empty blob');
				return new Blob([], { type: 'application/octet-stream' });
			}
			
			//console.log(`[INFO] Total file size: ${totalSize} bytes (${(totalSize / 1024 / 1024).toFixed(2)} MB)`);
			
			//if (totalSize < 1000) {
			//	//console.log(`[INFO] Small file size detected: ${totalSize} bytes, returning empty blob`);
			//	return new Blob([], { type: 'application/octet-stream' });
			//}
			
			// ★★★ ファイルサイズに応じてチャンクサイズを動的調整 ★★★
			 let chunkSize;
			 if (totalSize > 1000 * 1024 * 1024) { // 1GB以上
				 chunkSize = 2 * 1024 * 1024; // 2MB
			 } else if (totalSize > 500 * 1024 * 1024) { // 500MB以上
				 chunkSize = 3 * 1024 * 1024; // 3MB
			 } else if (totalSize > 100 * 1024 * 1024) { // 100MB以上
				 chunkSize = 5 * 1024 * 1024; // 5MB
			 } else if (totalSize > 1024) { // 1KB以上
				 chunkSize = 10 * 1024 * 1024; // 10MB
			 } else {
				 // ★★★ 1KB未満のファイルは一度にダウンロード ★★★
				 chunkSize = totalSize;
				 console.log(`[INFO] Very small file detected (${totalSize} bytes), downloading in one request`);
			 }
			
			const chunks = [];
			let downloaded = 0;
			const totalChunks = Math.ceil(totalSize / chunkSize);
			let failedChunks = 0;
			const maxFailedChunks = Math.ceil(totalChunks * 0.1); // 全体の10%まで失敗を許容
			
			//console.log(`[INFO] Total chunks: ${totalChunks}, chunk size: ${(chunkSize / 1024 / 1024).toFixed(1)}MB`);
			
			// ★★★ チャンクダウンロードのメインループ ★★★
			for (let start = 0; start < totalSize; start += chunkSize) {
				const end = Math.min(start + chunkSize - 1, totalSize - 1);
				const chunkIndex = Math.floor(start / chunkSize) + 1;
				
				try {
					//console.log(`[INFO] Downloading chunk ${chunkIndex}/${totalChunks}: ${start}-${end} (${end - start + 1} bytes)`);
					
					// ★★★ リトライ機能付きのチャンクダウンロード ★★★
					const chunk = await downloadChunkWithRetry(url, start, end);
					chunks.push(chunk);
					downloaded += chunk.size;
					
					// プログレス計算を修正：70-100%の範囲でマッピング
					const chunkProgress = (downloaded / totalSize) * 100;
					const mappedProgress = 70 + (chunkProgress * 0.3); // 70% + (0-30%)
					updateProgress(Math.round(mappedProgress));
					
					//console.log(`[INFO] Downloaded chunk ${chunkIndex}/${totalChunks}: ${chunk.size} bytes. Total: ${downloaded}/${totalSize} bytes (${mappedProgress.toFixed(1)}%)`);
					
				} catch (chunkError) {
					failedChunks++;
					console.error(`[ERROR] Failed to download chunk ${chunkIndex}/${totalChunks} after retries: ${chunkError.message}`);
					
					// ★★★ 失敗したチャンクが許容範囲を超えた場合はエラー ★★★
					if (failedChunks > maxFailedChunks) {
						throw new Error(`Too many failed chunks: ${failedChunks}/${totalChunks}. Download aborted.`);
					}
					
					// ★★★ 失敗したチャンクは空のBlobで代替 ★★★
					console.warn(`[WARN] Replacing failed chunk ${chunkIndex} with empty data`);
					const emptyChunk = new Blob([], { type: 'application/octet-stream' });
					chunks.push(emptyChunk);
					
					// プログレス更新（失敗したチャンクも進捗に含める）
					const chunkProgress = ((chunkIndex) / totalChunks) * 100;
					const mappedProgress = 70 + (chunkProgress * 0.3);
					updateProgress(Math.round(mappedProgress));
				}
			}
			
			//console.log(`[INFO] All chunks processed. Creating final blob from ${chunks.length} chunks (${failedChunks} failed)`);
			const finalBlob = new Blob(chunks);
			//console.log(`[INFO] Final blob size: ${finalBlob.size} bytes (${(finalBlob.size / 1024 / 1024).toFixed(2)} MB)`);
			
			// ★★★ 失敗したチャンクがある場合は警告ログ ★★★
			if (failedChunks > 0) {
				console.warn(`[WARN] Download completed with ${failedChunks} failed chunks out of ${totalChunks} total chunks`);
			}
			
			return finalBlob;
			
		} catch (error) {
			// ★★★ 0バイトファイル関連のエラーは静かに処理 ★★★
			if (error.message.includes('0') || error.message.includes('empty')) {
				//console.log(`[INFO] 0-byte file processing: ${error.message}`);
			} else {
				console.error(`[ERROR] Chunk download failed: ${error.message}`);
			}
			throw error;
		}
	};

	// ★★★ リトライ機能付きのチャンクダウンロード関数（新規追加） ★★★
	const downloadChunkWithRetry = async (url, start, end, retryCount = 0) => {
		const maxRetries = 3;
		const retryDelay = 1000; // 初期遅延時間（ミリ秒）
		
		try {
			return await downloadChunk(url, start, end);
		} catch (error) {
			if (retryCount < maxRetries) {
				const delay = retryDelay * Math.pow(2, retryCount); // 指数バックオフ
				console.warn(`[WARN] Chunk download failed, retrying (${retryCount + 1}/${maxRetries}) after ${delay}ms for range ${start}-${end}: ${error.message}`);
				
				// 遅延後にリトライ
				await new Promise(resolve => setTimeout(resolve, delay));
				return downloadChunkWithRetry(url, start, end, retryCount + 1);
			} else {
				console.error(`[ERROR] Max retries (${maxRetries}) exceeded for range ${start}-${end}`);
				throw error;
			}
		}
	};

	// 一括ダウンロード専用のチャンクダウンロード関数（リトライ機能強化版）
	const downloadWithChunksForBatch = async (url, currentIndex, totalFiles) => {
		try {
			//console.log(`[INFO] Starting batch chunk download for file ${currentIndex + 1}/${totalFiles}: ${url}`);
			
			const headResponse = await fetch(url, { 
				method: 'HEAD',
				headers: getHeader(SYS_ROLE.FILE_MANAGEMENT).headers
			});
			
			if (!headResponse.ok) {
				throw new Error(`ファイル情報の取得に失敗しました: ${headResponse.status}`);
			}
			
			const contentLengthHeader = headResponse.headers.get('Content-Length');
			const totalSize = parseInt(contentLengthHeader || '0');
			
			// ★★★ 0バイトファイルのチェックを追加 ★★★
			if (totalSize === 0) {
				//console.log(`[INFO] 0-byte file detected in chunk download for file ${currentIndex + 1}/${totalFiles}`);
				return new Blob([], { type: 'application/octet-stream' });
			}
			
			// ★★★ ファイルサイズが取得できない場合のエラーハンドリング ★★★
			if (isNaN(totalSize) || totalSize < 0) {
				console.warn(`[WARN] Invalid file size for file ${currentIndex + 1}/${totalFiles}: ${totalSize}`);
				throw new Error('ファイルサイズが取得できませんでした');
			}
			
			// ★★★ 一括ダウンロード用の動的チャンクサイズ調整 ★★★
			let chunkSize;
			if (totalSize > 1000 * 1024 * 1024) { // 1GB以上
				chunkSize = 2 * 1024 * 1024; // 2MB
			} else if (totalSize > 500 * 1024 * 1024) { // 500MB以上
				chunkSize = 3 * 1024 * 1024; // 3MB
			} else if (totalSize > 100 * 1024 * 1024) { // 100MB以上
				chunkSize = 5 * 1024 * 1024; // 5MB
			} else {
				chunkSize = 10 * 1024 * 1024; // 10MB
			}
			
			const chunks = [];
			let downloaded = 0;
			const totalChunks = Math.ceil(totalSize / chunkSize);
			let failedChunks = 0;
			const maxFailedChunks = Math.ceil(totalChunks * 0.15); // 一括ダウンロードでは15%まで失敗を許容
			
			//console.log(`[INFO] Batch file ${currentIndex + 1}/${totalFiles}: ${totalChunks} chunks, ${(chunkSize / 1024 / 1024).toFixed(1)}MB each`);
			
			// ★★★ チャンクダウンロードのメインループ（リトライ機能付き） ★★★
			for (let start = 0; start < totalSize; start += chunkSize) {
				const end = Math.min(start + chunkSize - 1, totalSize - 1);
				const chunkIndex = Math.floor(start / chunkSize) + 1;
				
				try {
					// ★★★ リトライ機能付きのチャンクダウンロード ★★★
					const chunk = await downloadChunkWithRetryForBatch(url, start, end, currentIndex, totalFiles);
					chunks.push(chunk);
					downloaded += chunk.size;
					
				} catch (chunkError) {
					failedChunks++;
					console.error(`[ERROR] Failed to download chunk ${chunkIndex}/${totalChunks} for file ${currentIndex + 1}/${totalFiles} after retries: ${chunkError.message}`);
					
					// ★★★ 失敗したチャンクが許容範囲を超えた場合の処理 ★★★
					if (failedChunks > maxFailedChunks) {
						console.error(`[ERROR] Too many failed chunks (${failedChunks}/${totalChunks}) for file ${currentIndex + 1}/${totalFiles}. Treating as 0-byte file.`);
						// 一括ダウンロードでは完全に失敗したファイルは0バイトファイルとして扱う
						return new Blob([], { type: 'application/octet-stream' });
					}
					
					// ★★★ 失敗したチャンクは空のBlobで代替 ★★★
					console.warn(`[WARN] Replacing failed chunk ${chunkIndex} with empty data for file ${currentIndex + 1}/${totalFiles}`);
					const emptyChunk = new Blob([], { type: 'application/octet-stream' });
					chunks.push(emptyChunk);
				}
			}
			
			const finalBlob = new Blob(chunks);
			
			// ★★★ 失敗したチャンクがある場合は警告ログ ★★★
			if (failedChunks > 0) {
				console.warn(`[WARN] Batch file ${currentIndex + 1}/${totalFiles} completed with ${failedChunks} failed chunks out of ${totalChunks} total chunks`);
			}
			
			//console.log(`[INFO] Batch chunk download completed for file ${currentIndex + 1}/${totalFiles}. Size: ${finalBlob.size} bytes`);
			
			return finalBlob;
			
		} catch (error) {
			console.error(`[ERROR] Batch chunk download failed for file ${currentIndex + 1}/${totalFiles}: ${error.message}`);
			
			// ★★★ 一括ダウンロードでは個別ファイルの失敗を0バイトファイルとして処理 ★★★
			console.warn(`[WARN] Treating failed file ${currentIndex + 1}/${totalFiles} as 0-byte file to continue batch download`);
			return new Blob([], { type: 'application/octet-stream' });
		}
	};

	// ★★★ 一括ダウンロード用のリトライ機能付きチャンクダウンロード関数（新規追加） ★★★
	const downloadChunkWithRetryForBatch = async (url, start, end, currentIndex, totalFiles, retryCount = 0) => {
		const maxRetries = 2; // 一括ダウンロードでは少し控えめに
		const retryDelay = 500; // より短い遅延
		
		try {
			return await downloadChunk(url, start, end);
		} catch (error) {
			if (retryCount < maxRetries) {
				const delay = retryDelay * Math.pow(1.5, retryCount); // 緩やかな指数バックオフ
				console.warn(`[WARN] Batch chunk download failed, retrying (${retryCount + 1}/${maxRetries}) after ${delay}ms for file ${currentIndex + 1}/${totalFiles}, range ${start}-${end}: ${error.message}`);
				
				// 遅延後にリトライ
				await new Promise(resolve => setTimeout(resolve, delay));
				return downloadChunkWithRetryForBatch(url, start, end, currentIndex, totalFiles, retryCount + 1);
			} else {
				console.error(`[ERROR] Max retries (${maxRetries}) exceeded for file ${currentIndex + 1}/${totalFiles}, range ${start}-${end}`);
				throw error;
			}
		}
	};
		
	// 個別チャンクダウンロード関数を修正（リトライ機能付き）
	const downloadChunk = async (url, start, end, retryCount = 0) => {
		const maxRetries = 3;
		const retryDelay = 1000; // 初期遅延時間（ミリ秒）
		
		return new Promise((resolve, reject) => {
			const xhr = new XMLHttpRequest();
			xhr.responseType = 'blob';
			xhr.timeout = 20 * 60 * 1000; // 20分タイムアウト（延長）
			
			xhr.addEventListener('load', () => {
				if (xhr.status === 206 || xhr.status === 200) {
					const blob = xhr.response;
					const expectedSize = end - start + 1;
					
					if (blob.size === 0) {
						handleRetry(new Error(`Empty chunk received for range ${start}-${end}`));
						return;
					}
					
					resolve(blob);
				} else {
					console.error(`[ERROR] Chunk download failed: status=${xhr.status}, range=${start}-${end}`);
					handleRetry(new Error(`Chunk download failed: ${xhr.status}`));
				}
			});
			
			xhr.addEventListener('error', (event) => {
				console.error(`[ERROR] Chunk network error for range ${start}-${end}:`, event);
				handleRetry(new Error('Chunk download network error'));
			});
			
			xhr.addEventListener('timeout', () => {
				console.error(`[ERROR] Chunk timeout for range ${start}-${end}`);
				handleRetry(new Error('Chunk download timeout'));
			});
			
			// リトライ処理のヘルパー関数
			const handleRetry = async (error) => {
				if (retryCount < maxRetries) {
					const delay = retryDelay * Math.pow(2, retryCount); // 指数バックオフ
					console.warn(`[WARN] Chunk download failed, retrying (${retryCount + 1}/${maxRetries}) after ${delay}ms for range ${start}-${end}`);
					
					setTimeout(async () => {
						try {
							const result = await downloadChunk(url, start, end, retryCount + 1);
							resolve(result);
						} catch (retryError) {
							reject(retryError);
						}
					}, delay);
				} else {
					console.error(`[ERROR] Max retries (${maxRetries}) exceeded for range ${start}-${end}`);
					reject(error);
				}
			};
			
			xhr.open('GET', url);
			
			// Rangeヘッダーを設定
			xhr.setRequestHeader('Range', `bytes=${start}-${end}`);
			
			// その他のヘッダーを設定
			const headers = getHeader(SYS_ROLE.FILE_MANAGEMENT);
			if (headers && headers.headers) {
				Object.entries(headers.headers).forEach(([key, value]) => {
					if (key.toLowerCase() !== 'range') {
						xhr.setRequestHeader(key, value);
					}
				});
			}
			
			xhr.send();
		});
	};

	// 既存のdownloadWithProgress関数を置き換え
	const downloadWithProgress = async (url) => {
		try {
			// チャンク分割ダウンロードを使用
			return await downloadWithChunks(url);
		} catch (error) {
			// ★★★ 0バイトファイル関連のエラーは静かに処理 ★★★
			if (error.message.includes('0-byte') || 
				error.message.includes('Small file') ||
				error.message.includes('empty blob')) {
				//console.log(`[INFO] 0-byte file handled via fallback: ${error.message}`);
				return new Blob([], { type: 'application/octet-stream' });
			}
			
			console.warn(`[WARN] Chunk download failed, falling back to normal download: ${error.message}`);
			
			// フォールバック：通常のダウンロード
			return new Promise((resolve, reject) => {
				const xhr = new XMLHttpRequest();
				xhr.timeout = 4 * 60 * 60 * 1000;
				xhr.responseType = 'blob';
				
				xhr.addEventListener('progress', (event) => {
					if (event.lengthComputable) {
						const percentage = (event.loaded / event.total) * 100;
						updateProgress(percentage);
					}
				});

				xhr.addEventListener('timeout', () => {
					reject(new Error('ダウンロードがタイムアウトしました'));
				});

				xhr.addEventListener('load', () => {
					if (xhr.status === 200) {
						resolve(new Blob([xhr.response]));
					} else if (xhr.status === 206) { // Partial Content
						resolve(new Blob([xhr.response]));
					} else if (xhr.status === 503) {
						localStorage.removeItem("funcroleList");
						reject(new MaintenanceApiError());
					} else {
						const reader = new FileReader();
						reader.onload = () => {
							reject(new CustomApiError(reader.result));
						};
						reader.onerror = () => {
							reject(new CustomApiError("不明なエラーが発生しました"));
						};
						reader.readAsText(xhr.response);
					}
				});

				xhr.addEventListener('error', () => {
					reject(new Error('ダウンロードエラーが発生しました'));
				});

				xhr.open('GET', url);
				
				const headers = getHeader(SYS_ROLE.FILE_MANAGEMENT);
				if (headers && headers.headers) {
					Object.entries(headers.headers).forEach(([key, value]) => {
						if (key.toLowerCase() !== 'connection' && key.toLowerCase() !== 'upgrade') {
							xhr.setRequestHeader(key, value);
						}
					});
				}

				xhr.send();
			});
		}
	};

	// 一括ダウンロード用のSFTP対応ダウンロード関数を修正
	async function startDownloadForBatch(remotePath, currentIndex, totalFiles) {
		return new Promise(async (resolve, reject) => {
			try {
				// 最初のファイルの場合のみプログレスバーを表示
				if (currentIndex === 0) {
					showProgressBar();
					updateProgress(0);
				}
				
				// ジョブ開始API呼び出し
				const res = await fetch('/api/start-download', {
					method: 'POST',
					headers: { 
						'Content-Type': 'application/json',
						...getHeader(SYS_ROLE.FILE_MANAGEMENT).headers
					},
					body: JSON.stringify({ remotePath })
				});
	
				if (!res.ok) {
					if (res.status === 409) {
						// ★★★ 409エラーの場合は0バイトファイルとして処理 ★★★
						//console.log(`[INFO] 409 Conflict detected for file ${currentIndex + 1}, treating as 0-byte file`);
						
						// プログレス更新
						const completedProgress = ((currentIndex + 1) / totalFiles) * 90;
						updateProgress(Math.round(completedProgress));
						
						resolve(new Blob([], { type: 'application/octet-stream' }));
						return;
					}
					throw new Error(`ジョブ開始に失敗しました: ${res.status}`);
				}
				const { jobId } = await res.json();
				
				// 各ファイルでSignalR監視を行う
				const connection = new signalR.HubConnectionBuilder()
				.withUrl("/progressHub")
				.withAutomaticReconnect([0, 2000, 10000, 30000])
				.configureLogging(signalR.LogLevel.Warning)
				.build();
			
				// 接続状態の監視
				connection.onreconnecting((error) => {
					console.warn(`[WARN] SignalR reconnecting for file ${currentIndex + 1}:`, error);
				});
				
				connection.onreconnected((connectionId) => {
					//console.log(`[INFO] SignalR reconnected for file ${currentIndex + 1}:`, connectionId);
					connection.invoke("JoinGroup", jobId).catch(console.error);
				});
				
				connection.onclose((error) => {
					if (error) {
						console.error(`[ERROR] SignalR connection closed for file ${currentIndex + 1}:`, error);
					} else {
						//console.log(`[INFO] SignalR connection closed normally for file ${currentIndex + 1}`);
					}
				});
								
				try {
					await connection.start();
				} catch (error) {
					console.error(`[ERROR] SignalR connection failed for file ${currentIndex + 1}:`, error);
				}
			
				await connection.invoke("JoinGroup", jobId);

				// ★★★ ハートビート状態管理変数を追加 ★★★
				let heartbeatFailureCount = 0;
				let lastHeartbeatTime = Date.now();
				const MAX_HEARTBEAT_FAILURES = 3; // 連続失敗許容回数
				const HEARTBEAT_INTERVAL = 30000; // 30秒間隔
				const HEARTBEAT_TIMEOUT = 10000; // 10秒タイムアウト

				// ★★★ ハートビート実行関数を追加 ★★★
				const performHeartbeat = async () => {
					if (connection.state !== signalR.HubConnectionState.Connected) {
						//console.log(`[DEBUG] Skipping heartbeat for file ${currentIndex + 1} - connection not active`);
						return;
					}
				
					try {
						//console.log(`[DEBUG] Sending heartbeat using JoinGroup for file ${currentIndex + 1}...`);
						
						// Pingの代わりにJoinGroupを使用してヘルスチェック
						const heartbeatPromise = connection.invoke("JoinGroup", jobId);  // ← ここを修正
						const timeoutPromise = new Promise((_, reject) => {
							setTimeout(() => reject(new Error('Heartbeat timeout')), HEARTBEAT_TIMEOUT);
						});
						
						// どちらか早い方で解決
						await Promise.race([heartbeatPromise, timeoutPromise]);
						
						// ハートビート成功
						//console.log(`[DEBUG] Heartbeat successful using JoinGroup for file ${currentIndex + 1}`);
						heartbeatFailureCount = 0;
						lastHeartbeatTime = Date.now();
						
					} catch (error) {
						heartbeatFailureCount++;
						console.warn(`[WARN] Heartbeat failed for file ${currentIndex + 1} (${heartbeatFailureCount}/${MAX_HEARTBEAT_FAILURES}):`, error.message);
						
						// 連続失敗が許容回数を超えた場合
						if (heartbeatFailureCount >= MAX_HEARTBEAT_FAILURES) {
							console.error(`[ERROR] Maximum heartbeat failures reached for file ${currentIndex + 1}, attempting reconnection`);
							
							try {
								// 強制的に接続を切断して再接続を試行
								await connection.stop();
								//console.log(`[INFO] Connection stopped for file ${currentIndex + 1}, attempting restart...`);
								
								await connection.start();
								//console.log(`[INFO] Connection restarted successfully for file ${currentIndex + 1}`);
								
								// ジョブグループに再参加
								await connection.invoke("JoinGroup", jobId);
								//console.log(`[INFO] Rejoined job group after reconnection for file ${currentIndex + 1}`);
								
								// 失敗カウントをリセット
								heartbeatFailureCount = 0;
								lastHeartbeatTime = Date.now();
								
							} catch (reconnectError) {
								console.error(`[ERROR] Failed to reconnect after heartbeat failures for file ${currentIndex + 1}:`, reconnectError);
								// 再接続に失敗した場合は処理を継続（ポーリングに依存）
							}
						}
					}
				};
				
				// ★★★ 1. 定期的な接続状態チェック ★★★
				const connectionMonitor = setInterval(() => {
					if (connection.state === signalR.HubConnectionState.Disconnected) {
						console.warn(`[WARN] SignalR disconnected for file ${currentIndex + 1}, attempting reconnection`);
						connection.start()
							.then(() => {
								//console.log(`[INFO] SignalR reconnection successful for file ${currentIndex + 1}`);
								// 再接続後にジョブグループに再参加
								return connection.invoke("JoinGroup", jobId);
							})
							.catch((error) => {
								console.error(`[ERROR] SignalR reconnection failed for file ${currentIndex + 1}:`, error);
							});
					} else if (connection.state === signalR.HubConnectionState.Connecting) {
						//console.log(`[INFO] SignalR is connecting for file ${currentIndex + 1}...`);
					}
				}, 30000);

				// ★★★ 2. ハートビート定期実行 ★★★
				const heartbeatInterval = setInterval(performHeartbeat, HEARTBEAT_INTERVAL);

				// ★★★ 3. ハートビート健全性チェック ★★★
				const heartbeatHealthCheck = setInterval(() => {
					const timeSinceLastHeartbeat = Date.now() - lastHeartbeatTime;
					
					// 2分間ハートビートが成功していない場合
					if (timeSinceLastHeartbeat > 2 * 60 * 1000) {
						console.warn(`[WARN] No successful heartbeat for 2 minutes for file ${currentIndex + 1}`);
						
						// 接続状態を確認
						if (connection.state === signalR.HubConnectionState.Connected) {
							console.warn(`[WARN] Connection appears active but heartbeat is failing for file ${currentIndex + 1}`);
							// 即座にハートビートを実行
							performHeartbeat();
						}
					}
				}, 60000); // 1分ごとにチェック

				
				// 現在のファイルの最後の進捗を保持
				let lastFileProgress = 0;
				
				connection.on("ProgressUpdate", (progressData) => {
					//console.log(`[DEBUG] Raw progress data for file ${currentIndex + 1}:`, progressData);
					
					// 一括ダウンロードの場合は全体進捗を計算
					const fileBaseProgress = (currentIndex / totalFiles) * 90; // 90%まで使用（残り10%はZIP生成用）
					const fileProgressRange = 90 / totalFiles;
					
					let fileProgress = lastFileProgress; // デフォルトは前回の進捗を維持
					
					switch (progressData.type) {
						case 'sftp_start':
							fileProgress = 1;
							break;
						case 'sftp_connected':
							fileProgress = 2;
							break;
						case 'sftp_progress':
							const sftpProgress = Math.min(progressData.percentage || 0, 100);
							fileProgress = 2 + (sftpProgress * 0.68); // 2% + (0-68%)
							break;
						case 'sftp_completed':
							fileProgress = 70;
							break;
						case 'download_ready':
							fileProgress = 72; // SFTP完了後の準備段階
							break;
						case 'download_start':
							fileProgress = 75;
							break;
						case 'download_completed':
							fileProgress = 100;
							break;
						case 'download_error':
						case 'error':
							console.error(`[ERROR] Download error via SignalR for file ${currentIndex + 1}:`, progressData.message);
							// エラー時は全ての監視を停止
							clearInterval(connectionMonitor);
							clearInterval(heartbeatInterval);
							clearInterval(heartbeatHealthCheck);
							clearInterval(interval);
							clearTimeout(timeout);
							connection.stop();
							reject(new Error(progressData.message || 'SignalRエラーが発生しました'));
							return;
						default:
							// 未知のタイプの場合は前回の進捗を維持
							console.warn(`[WARN] Unknown progress type: ${progressData.type} for file ${currentIndex + 1}`);
							fileProgress = lastFileProgress;
							break;
					}
					
					// 進捗が後退しないようにチェック
					if (fileProgress < lastFileProgress) {
						console.warn(`[WARN] Progress would go backwards from ${lastFileProgress}% to ${fileProgress}% for file ${currentIndex + 1}. Maintaining previous progress.`);
						fileProgress = lastFileProgress;
					}
					
					lastFileProgress = fileProgress;
					
					// 全体進捗を計算：現在のファイルのベース進捗 + 現在のファイル内進捗
					const totalProgress = fileBaseProgress + (fileProgress * fileProgressRange / 100);
					updateProgress(Math.round(totalProgress));
					
					//console.log(`[INFO] Batch progress - File ${currentIndex + 1}/${totalFiles}: ${fileProgress}% -> Total: ${totalProgress.toFixed(1)}%`);
				});
				
				// ポーリング処理
				const timeout = setTimeout(() => {
					// 全ての監視を停止
					clearInterval(connectionMonitor);
					clearInterval(heartbeatInterval);
					clearInterval(heartbeatHealthCheck);
					connection.stop();
					reject(new Error('ダウンロードがタイムアウトしました'));
				}, 4 * 60 * 60 * 1000);

				const interval = setInterval(async () => {
					try {  // ← この try に対応する catch が必要
						const sanitizedJobId = sanitizeJobId(jobId);
						if (!sanitizedJobId) {
							throw new Error('Invalid job ID');
						}
						const statusRes = await fetch(`/api/job-status/${encodeURIComponent(sanitizedJobId)}`, {
							headers: getHeader(SYS_ROLE.FILE_MANAGEMENT).headers
						});
						
						if (!statusRes.ok) {
							throw new Error(`ステータス確認に失敗しました: ${statusRes.status}`);
						}
						
						const { status } = await statusRes.json();

						if (status === 'Completed') {
							clearInterval(interval);
							clearInterval(connectionMonitor);
							clearInterval(heartbeatInterval);
							clearInterval(heartbeatHealthCheck);
							clearTimeout(timeout);
							
							// LeaveGroupを安全に実行
							try {
								await connection.invoke("LeaveGroup", jobId);
								//console.log(`[INFO] Successfully left job group for file ${currentIndex + 1}`);
							} catch (leaveError) {
								console.warn(`[WARN] Failed to leave group for file ${currentIndex + 1}:`, leaveError.message);
							}
							
							// ファイル完了時の進捗を確実に設定
							const completedProgress = ((currentIndex + 1) / totalFiles) * 90;
							updateProgress(Math.round(completedProgress));
							//console.log(`[INFO] File ${currentIndex + 1}/${totalFiles} completed. Progress: ${completedProgress.toFixed(1)}%`);

							// ダウンロード処理を先に実行
							const downloadUrl = `/api/download-job/${jobId}`;
							const blob = await downloadWithProgressForBatch(downloadUrl, currentIndex, totalFiles);
							
							// 接続を安全に切断（非同期で実行）
							setTimeout(async () => {
								try {
									if (connection.state === signalR.HubConnectionState.Connected) {
										await connection.stop();
										//console.log(`[INFO] Connection gracefully stopped for file ${currentIndex + 1}`);
									}
								} catch (stopError) {
									console.warn(`[WARN] Error stopping connection for file ${currentIndex + 1}:`, stopError.message);
								}
							}, 200);
							
							resolve(blob);
							
						} else if (status === 'Failed') {
							clearInterval(interval);
							clearInterval(connectionMonitor);
							clearInterval(heartbeatInterval);
							clearInterval(heartbeatHealthCheck);
							clearTimeout(timeout);
							
							// 失敗時も安全に接続を切断
							try {
								await connection.invoke("LeaveGroup", jobId);
							} catch (leaveError) {
								console.warn(`[WARN] Failed to leave group on failure for file ${currentIndex + 1}:`, leaveError.message);
							}
							
							setTimeout(async () => {
								try {
									if (connection.state === signalR.HubConnectionState.Connected) {
										await connection.stop();
									}
								} catch (stopError) {
									console.warn(`[WARN] Error stopping connection on failure:`, stopError.message);
								}
							}, 100);
							
							reject(new Error('ダウンロードに失敗しました'));
						}
						
					} catch (error) {  // ← setInterval内のtryに対応するcatch
						clearInterval(interval);
						clearInterval(connectionMonitor);
						clearInterval(heartbeatInterval);
						clearInterval(heartbeatHealthCheck);
						clearTimeout(timeout);
						
						// エラー時も安全に接続を切断
						setTimeout(async () => {
							try {
								if (connection.state === signalR.HubConnectionState.Connected) {
									await connection.stop();
								}
							} catch (stopError) {
								console.warn(`[WARN] Error stopping connection on error:`, stopError.message);
							}
						}, 100);
						
						reject(error);
					}
				}, 3000);
				
			} catch (error) {
				reject(error);
			}
		});
	}

	// 一括ダウンロードボタン押下処理
	const handleAllDownloadClick = async () => {
		if (0 < downloadList.length && downloadList.length <= 10) {
			try {
				const service = serviceList.find(service => service.auditCode === formValues.service);
				const org = orgList.find(org => org.orgLevel0Code === formValues.org);
				const proj = projList.find(proj => proj.projCode === formValues.proj);

				const fileName = service.auditName + '_' + org.comp + '_' + proj.projName + '_' + getFormattedDate() + '.zip';
				const options = { 'suggestedName': fileName };
				// 最初に保存先ディレクトリを指定
				const handle = await window.showSaveFilePicker(options);
				// 書き込み用のストリームを開く
				const writableStream = await handle.createWritable();

				const zip = new JSZip();
				const totalFiles = downloadList.length;

				for (let i = 0; i < downloadList.length; i++) {
					const element = downloadList[i];
					//console.log(`[INFO] Processing file ${i + 1}/${totalFiles}: ${element.fileName}`);

					// ダウンロードAPI:
					const url = setURL(API_URL.DOWNLOAD) + '/' + element.fileId + '?';
					const params = {
						'auditCode': formValues.service,
						'projCode': formValues.proj,
						'projRateNo': element.projRateNo
					};
					const urlSearchParam = String(new URLSearchParams(params));

					let blob;
					if (process.env.NODE_ENV === 'production') {
						// ★★★ ファイルサイズを事前チェック（エラーハンドリング強化） ★★★
						//console.log(`[INFO] Checking file size for batch download: ${element.fileName}`);
						
						let fileSize = -1;
						try {
							fileSize = await checkFileSize(element.fileId);
							//console.log(`[INFO] File size detected: ${fileSize} bytes for ${element.fileName}`);
						} catch (sizeCheckError) {
							console.warn(`[WARN] File size check failed for ${element.fileName}:`, sizeCheckError.message);
							fileSize = -1; // サイズ不明として処理
						}

						if (fileSize === 0) {
							// ★★★ Case 1: 0バイトファイルの場合の処理 ★★★
							//console.log(`[INFO] Handling 0-byte file in batch: ${element.fileName}`);
							
							// 空のBlobを作成（SFTP処理をスキップ）
							blob = new Blob([], { type: 'application/octet-stream' });
							
							// プログレス更新（このファイルの処理完了として扱う）
							const completedProgress = ((i + 1) / totalFiles) * 90; // 90%まで使用（残り10%はZIP生成用）
							updateProgress(Math.round(completedProgress));
							
							//console.log(`[INFO] 0-byte file processed. Progress: ${completedProgress.toFixed(1)}%`);

						} else if (fileSize > 0) {
							// ★★★ Case 2: 通常のファイルの場合の処理 ★★★
							//console.log(`[INFO] Processing normal file: ${element.fileName} (${fileSize} bytes)`);
							
							try {
								blob = await startDownloadForBatch(url + urlSearchParam, i, totalFiles);
								//console.log(`[INFO] Normal file processed successfully: ${element.fileName}`);
							} catch (normalFileError) {
								console.error(`[ERROR] Normal file download failed for ${element.fileName}:`, normalFileError.message);
								
								// ★★★ 通常ファイルでもエラー時は0バイトファイルとして処理 ★★★
								if (normalFileError.message.includes('409') || 
									normalFileError.message.includes('Conflict') ||
									normalFileError.message.includes('ファイルサイズが取得できませんでした') ||
									normalFileError.message.includes('ジョブ開始に失敗しました')) {
									
									//console.log(`[INFO] Treating normal file error as 0-byte file: ${element.fileName}`);
									blob = new Blob([], { type: 'application/octet-stream' });
									
									const completedProgress = ((i + 1) / totalFiles) * 90;
									updateProgress(Math.round(completedProgress));
								} else {
									throw normalFileError;
								}
							}

						} else {
							// ★★★ Case 3: サイズ不明の場合のフォールバック処理（強化版） ★★★
							console.warn(`[WARN] File size unknown for: ${element.fileName}, attempting download with comprehensive error handling`);
							
							try {
								blob = await startDownloadForBatch(url + urlSearchParam, i, totalFiles);
								//console.log(`[INFO] Unknown size file processed successfully: ${element.fileName}`);
							} catch (unknownSizeError) {
								console.error(`[ERROR] Unknown size file download failed for ${element.fileName}:`, unknownSizeError.message);
								
								// ★★★ より広範囲のエラーを0バイトファイルとして処理 ★★★
								if (unknownSizeError.message.includes('409') || 
									unknownSizeError.message.includes('Conflict') ||
									unknownSizeError.message.includes('ファイルサイズが取得できませんでした') ||
									unknownSizeError.message.includes('ジョブ開始に失敗しました') ||
									unknownSizeError.message.includes('ファイル情報の取得に失敗しました') ||
									unknownSizeError.message.includes('HEAD') ||
									unknownSizeError.message.includes('Content-Length')) {
									
									//console.log(`[INFO] Treating unknown size file error as 0-byte file: ${element.fileName}`);
									blob = new Blob([], { type: 'application/octet-stream' });
									
									// プログレス更新
									const completedProgress = ((i + 1) / totalFiles) * 90;
									updateProgress(Math.round(completedProgress));
								} else {
									// ★★★ 最後の手段：どんなエラーでも0バイトファイルとして処理 ★★★
									console.warn(`[WARN] Unexpected error, treating as 0-byte file: ${element.fileName}`, unknownSizeError);
									blob = new Blob([], { type: 'application/octet-stream' });
									
									const completedProgress = ((i + 1) / totalFiles) * 90;
									updateProgress(Math.round(completedProgress));
								}
							}
						}
					} else {
						// ★★★ ローカルデバッグ時の処理（既存のコードを維持） ★★★
						// 最初のファイルでプログレスバー表示開始
						if (i === 0) {
							showProgressBar();
						}
						
						// プログレスバーのシミュレーション
						const baseProgress = (i / totalFiles) * 90; // 90%まで使用
						const fileProgress = ((i + 1) / totalFiles) * 90;

						// ファイル単位でのプログレス更新
						for (let progress = baseProgress; progress <= fileProgress; progress += 5) {
							updateProgress(Math.min(progress, fileProgress));
							await new Promise(resolve => setTimeout(resolve, 50));
						}

						// ★★★ デバッグ用：時々0バイトファイルをシミュレート ★★★
						if (i % 3 === 0) {
							// 3つに1つは0バイトファイルとしてテスト
							blob = new Blob([], { type: 'application/octet-stream' });
							//console.log(`[DEBUG] Simulating 0-byte file: ${element.fileName}`);
						} else {
							blob = new Blob([createLargeContent(10)], { type: 'text/csv' }); // 10MBのファイル
						}
					}

					// ★★★ ZIPファイルに追加（0バイトファイルも正常に追加される） ★★★
					zip.file(element.fileName, blob);
					//console.log(`[INFO] Added to ZIP: ${element.fileName} (${blob.size} bytes)`);
					
					// ★★★ メモリ使用量の監視 ★★★
					if ((i + 1) % 3 === 0) {
						//console.log(`[INFO] Progress: ${i + 1}/${totalFiles} files processed`);
					}
				}
					
				// ZIPファイル生成のプログレス表示
				//console.log('[INFO] Starting ZIP file generation...');
				updateProgress(95);

				// ZIPファイルを生成してダウンロード
				const content = await zip.generateAsync({ type: 'blob' });
				//console.log(`[INFO] ZIP file generated successfully. Size: ${content.size} bytes`);

				// 最終段階のプログレス表示
				updateProgress(100);

				await writableStream.write(content);
				await writableStream.close();
				//console.log('[INFO] ZIP file download completed successfully');

				setDialogStatus(DIALOG_STATUS.OK_DIALOG);
				const message = t('message.1000930');
				setDialogOpen(true);
				setDialogContent(message);

			} catch (error) {
				if (error instanceof DOMException) {
					// ファイル保存ダイアログを閉じただけなので何もしない
					//console.log('[INFO] File save dialog was cancelled by user');
				} else {
					const detailErrorMessage = 'ダウンロード処理でエラーが発生しました。\n(An error occurred during the download process.)';
					console.error(`[ERROR] ダウンロード処理でエラーが発生: ${error.message}`);
					console.error('[ERROR] Full error details:', error);
					commonError(error, detailErrorMessage);
				}
			} finally {
				hideProgressBar();
			}
		} else if (downloadList.length === 0) {
			setDialogStatus(DIALOG_STATUS.OK_DIALOG);
			const message = t('message.1000920');
			setDialogOpen(true);
			setDialogContent(message);
		} else {
			setDialogStatus(DIALOG_STATUS.OK_DIALOG);
			const message = t('message.1000910');
			setDialogOpen(true);
			setDialogContent(message);
		}
	};
	
	// 一括ダウンロード用のプログレス付きダウンロード関数を修正
	const downloadWithProgressForBatch = async (url, currentIndex, totalFiles) => {
		try {
			//console.log(`[INFO] Starting batch download ${currentIndex + 1}/${totalFiles} for: ${url}`);
			
			// ★★★ まずファイルサイズをチェック ★★★
			const headResponse = await fetch(url, { 
				method: 'HEAD',
				headers: getHeader(SYS_ROLE.FILE_MANAGEMENT).headers
			});
			
			if (!headResponse.ok) {
				throw new Error(`ファイル情報の取得に失敗しました: ${headResponse.status}`);
			}
			
			const contentLengthHeader = headResponse.headers.get('Content-Length');
			const totalSize = parseInt(contentLengthHeader || '0');
			
			// ★★★ 0バイトファイルの場合は直接空のBlobを返す ★★★
			if (totalSize === 0) {
				//console.log(`[INFO] 0-byte file detected in batch download ${currentIndex + 1}/${totalFiles}, returning empty blob`);
				return new Blob([], { type: 'application/octet-stream' });
			}
			
			// ★★★ 通常のファイルの場合はチャンクダウンロードを実行 ★★★
			const blob = await downloadWithChunksForBatch(url, currentIndex, totalFiles);
			
			//console.log(`[INFO] Batch download ${currentIndex + 1}/${totalFiles} completed. Size: ${blob.size} bytes`);
			
			return blob;
		} catch (error) {
			console.error(`[ERROR] Batch download failed for file ${currentIndex + 1}/${totalFiles}: ${error.message}`);
			
			// ★★★ エラーが発生した場合も0バイトファイルとして処理 ★★★
			if (error.message.includes('ファイルサイズが取得できませんでした') || 
				error.message.includes('ファイル情報の取得に失敗しました')) {
				//console.log(`[INFO] Treating failed file as 0-byte file: ${currentIndex + 1}/${totalFiles}`);
				return new Blob([], { type: 'application/octet-stream' });
			}
			
			throw error;
		}
	};

	// 現在日付を取得する処理
	const getFormattedDate = () => {
		const date = new Date();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
		const hours = String(date.getHours()).padStart(2, '0');
		const minutes = String(date.getMinutes()).padStart(2, '0');
		const seconds = String(date.getSeconds()).padStart(2, '0');
	
		return `${month}${day}${hours}${minutes}${seconds}`;
	};

	/**
	 * 削除ボタン押下時の処理
	 * @param {object} row 選択している行の情報
	 */
	const handleDeleteClick = (row) => {
		const selectedObj = { projRateNo: row.projRateNo, fileId: row.fileId };
		setSelectedData({ ...selectedData, ...selectedObj });
		const message = setMessage(t('message.1001000'), [row.fileName]);
		setDialogStatus(DIALOG_STATUS.DELETE_CONFIRM_DIALOG);
		setConfirmDialogOpen(true);
		setConfirmDialogContent(message);

		//グローバル変数から削除
		if (globalDownloadList.some(item => item.projRateNo === row.projRateNo && item.fileId === row.fileId)) {
			// リストから削除
			globalDownloadList.filter(item => item.projRateNo !== row.projRateNo || item.fileId !== row.fileId);
		}
	};

	const [downloadList, setDownloadList] = useState([]);
	const [isAllCheckbox, setIsAllCheckbox] = useState(false);
	const [indeterminate, setIndeterminate] = useState(false);

	// チェックボックス選択時の処理
	const handleCheckboxClick = (row) => {
		const selectedObj = { projRateNo: row.projRateNo, fileId: row.fileId, fileName: row.fileName };
		setDownloadList((prevList) => {
			if (prevList.some(item => item.projRateNo === row.projRateNo && item.fileId === row.fileId)) {
				// グローバル変数のリストから削除
				globalDownloadList = globalDownloadList.filter(item => item.projRateNo !== row.projRateNo || item.fileId !== row.fileId);
				return prevList.filter(item => item.projRateNo !== row.projRateNo || item.fileId !== row.fileId);
			} else {
				// グローバル変数のリストに追加
				globalDownloadList = [...globalDownloadList, selectedObj];
				return [...prevList, selectedObj];
			}
		});

	};

	//一覧のチェックボックスが変更時走る処理（globalDownloadListが変更になったときの処理）
	const handleCheckboxSelect = useMemo(() => {
		if (isAllCheckbox === true) {
			setIndeterminate(false);

			if (downloadList.length == 0) {
				setIsAllCheckbox(false);
			}
		}
		else if (0 < downloadList.length && downloadList.length < fileManagementList.length) {
			setIndeterminate(true);
		}
		else {
			setIndeterminate(false);
		}
	}, [downloadList]);

	//サービス名等変更時走る処理（fileManagementListが変更になったときの処理）
	const handleDownloadChecklistInitialization = useMemo(() => {
		setDownloadList([]);
		setIsAllCheckbox(false);
		//ダウンロード対象リストのグローバル変数初期化
		globalDownloadList = [];
	}, [fileManagementList]);

	// 一括選択時の処理
	const handleAllCheck = () => {
		if (downloadList.length === 0) {
			const filteredList = fileManagementList.filter(item =>
				downloadableList.some(downloadableItem =>
					downloadableItem.projRateNo === item.projRateNo && downloadableItem.fileId === item.fileId
				)
			);
			//グローバル変数にセット
			filteredList.forEach(filteredItem => {
				globalDownloadList = [...globalDownloadList, filteredItem];
			})
			setDownloadList(filteredList);
			setIsAllCheckbox(true);
		}
		else {
			globalDownloadList = [];
			setDownloadList([]);
			setIsAllCheckbox(false);
		}
	};
	/**
	 * ダイアログでOKボタン押下時の処理
	 */
	const onOk = () => {
		setDialogStatus(DIALOG_STATUS.NO_DIALOG);
		setDialogOpen(false);
	};

	/**
	 * 削除時の確認ダイアログでOKボタン押下時の処理
	 */
	const onDeleteConfirmOk = async () => {
		setConfirmDialogOpen(false);
		// アップロード済ファイル削除API
		const url = setURL(API_URL.UPFILE);
		let formData = new FormData();
		formData.append('auditCode', formValues.service);
		formData.append('projCode', formValues.proj);
		formData.append('projRateNo', selectedData.projRateNo);
		formData.append('fileid', selectedData.fileId);
		const deleteApiParam = {
			url: url,
			sysRole: SYS_ROLE.FILE_MANAGEMENT,
			body: formData,
			success: deleteApiSuccess,
			error: deleteApiError,
		};
		await deleteApi(deleteApiParam);
	};

	/**
	 * 確認ダイアログでキャンセルボタン押下時の処理
	 */
	const onCancel = () => {
		setDialogStatus(DIALOG_STATUS.NO_DIALOG);
		setConfirmDialogOpen(false);
	};

	/**
	 * 認証APIの成功時の処理
	 */
	function authApiSuccess(response) {
		localStorage.setItem('token', JSON.stringify(response));
	};

	/**
	 * userid取得APIの成功時の処理
	 */
	function userIdApiSuccess(response) {
		localStorage.setItem('userid', JSON.stringify(response));
		localStorage.setItem('usrTypeCode', JSON.stringify(response));
		localStorage.setItem('email', JSON.stringify(response));
		localStorage.setItem('usrroleCode', JSON.stringify(response));

		// グローバル変数に直接セット
		globalUsrTypeCode = JSON.parse(localStorage.getItem("usrTypeCode")).usrTypeCode;
		setUsrTypeCode(response);

		// 列のフィルタリングを実行
		const filteredList = columns.filter(column => {
			//if (usr_type_code.usrTypeCode === "2" && column.accessor === 'downUsr') {
			if (globalUsrTypeCode === "2" && column.accessor === 'downUsr') {
				return false;
			}
			return true;
		});
		setfilteredColumnsList(filteredList);
	};

	/**
	 * 機能権限情報取得APIの成功時の処理
	 */
	function funcroleApiSuccess(response) {
		localStorage.setItem('funcroleList', JSON.stringify(response));
	};

	/**
	 * 認証APIの失敗時の処理
	 * @param {object} error エラーオブジェクト
	 */
	function authApiError(error) {
		const detailErrorMessage = '認証処理でエラーが発生しました。\n(An error occurred during the authentication process.)';
		commonError(error, detailErrorMessage);
		redirectToLogin();
	};

	/**
	 * userid取得APIの失敗時の処理
	 * @param {object} error エラーオブジェクト
	 */
	function userIdApiError(error) {
		const detailErrorMessage = 'ユーザー情報取得処理でエラーが発生しました。\n(An error occurred while getting user info process.)';
		commonError(error, detailErrorMessage);
		//認証期限切れの場合は再ログイン
		redirectToLogin();
	};

	/**
	 * 機能権限情報取得APIの失敗時の処理
	 * @param {object} error エラーオブジェクト
	 */
	function funcroleApiError(error) {
		const detailErrorMessage = '機能権限情報取得処理でエラーが発生しました。\n(An error occurred during the function authority information acquisition process.)';
		commonError(error, detailErrorMessage);
		//認証期限切れの場合は再ログイン
		redirectToLogin();
	};

	useEffect(() => {
		(async () => {
			//表示URLから認可コード取得
			const queryString = new URLSearchParams(document.location.search);
			var code = queryString.get('code');
			if (process.env.NODE_ENV !== 'production') {
				//ローカル起動のため、認証なしで動作させるためセット
				code = 'dev';
			}

			//アップロード完了メールに記載のURLから遷移時は認証も走るため、認証時処理を行うようにする
			//認証済みの状態でお知らせ画面を開く、認可コードをlocalStorageにセットしていない、もしくは直近で取得した認可コードと相違する場合は再度認証処理を行う
			if (code !== null) {
				if ((window.localStorage.getItem(['code']) === null) || (window.localStorage.getItem(['code']) !== code)) {
					localStorage.setItem('code', code);
					// アクセストークン取得API
					const urlAuth = setURL(API_URL.TOKEN);
					const getAuthApiParam = {
						url: `${urlAuth}?code=${code}`,
						sysRole: SYS_ROLE.PORTAL,
						success: authApiSuccess,
						error: authApiError,
						json: authData,
					}
					await getApi(getAuthApiParam);

					//userid取得API
					const urlUserId = setURL(API_URL.USERID);
					const getUserIDApiParam = {
						url: urlUserId,
						sysRole: SYS_ROLE.PORTAL,
						success: userIdApiSuccess,
						error: userIdApiError,
						json: userIdData,
					}
					await getApi(getUserIDApiParam);

					// 機能権限情報取得API
					const urlFuncrole = setURL(API_URL.FUNCROLE);
					const getFuncroleApiParam = {
						url: urlFuncrole,
						sysRole: SYS_ROLE.PORTAL,
						success: funcroleApiSuccess,
						error: funcroleApiError,
						json: funcroleData,
					}
					await getApi(getFuncroleApiParam);
				}
			}

			if (window.localStorage.getItem(['token']) === null) {
				navigate('/')
				return;
			}
			const search = location.search;
			var searchString = "";
			if (search !== '') {
				const query = new URLSearchParams(search);
				const serviceValue = query.has('auditCode') ? query.get('auditCode') : '';
				const orgValue = serviceValue !== '' && query.has('orgLevel0Code') ? query.get('orgLevel0Code') : '';
				const projValue = orgValue !== '' && serviceValue !== '' && query.has('projCode') ? query.get('projCode') : '';
				location.state = {
					service: serviceValue,
					org: orgValue,
					proj: projValue,
				}
				searchString = "?auditCode=" + serviceValue + "&orgLevel0Code=" + orgValue + "&projCode=" + projValue;
			}

			// 企業名選択の権限フラグを設定
			const orgSelectorAuthFlg = getFuncroleFlg(SYS_ROLE.FILE_MANAGEMENT, OBJ_ROLE.ORG_SELECTOR);
			setOrgSelectorAuthFlg(orgSelectorAuthFlg);
			// サービス名選択の権限フラグを設定
			const serviceSelectorAuthFlg = getFuncroleFlg(SYS_ROLE.FILE_MANAGEMENT, OBJ_ROLE.SERVICE_SELECTOR);
			setServiceSelectorAuthFlg(serviceSelectorAuthFlg);
			// プロジェクト名選択の権限フラグを設定
			const projSelectorAuthFlg = getFuncroleFlg(SYS_ROLE.FILE_MANAGEMENT, OBJ_ROLE.PROJ_SELECTOR);
			setProjSelectorAuthFlg(projSelectorAuthFlg);
			// アップロード日選択の権限フラグを設定
			setDeliveryDateRangeAuthFlg(getFuncroleFlg(SYS_ROLE.FILE_MANAGEMENT, OBJ_ROLE.DELIVERY_DATE_RANGE));

			if (orgSelectorAuthFlg && serviceSelectorAuthFlg && projSelectorAuthFlg) {
				// サービス選択項目取得API
				const url = setURL(API_URL.SELECT_ITEM_AUDIT);
				const getApiParam = {
					url: url,
					sysRole: SYS_ROLE.FILE_MANAGEMENT,
					success: selectServiceApiSuccess,
					error: selectItemApiError,
					json: selectItemAuditData
				}
				await getApi(getApiParam);
			}

			//ダウンロードユーザ表示有無の切り替え
			globalUsrTypeCode = JSON.parse(localStorage.getItem("usrTypeCode")).usrTypeCode;
			const filteredList = columns.filter(column => {
				//if (usr_type_code.usrTypeCode === "2" && column.accessor === 'downUsr') {
				if (globalUsrTypeCode === "2" && column.accessor === 'downUsr') {
					return false;
				}
				return true;
			});
			setfilteredColumnsList(filteredList);

			//バーのリンクが表示されないため、ファイル管理画面再表示
			if (searchString !== "") {
				navigate("/filemanagement" + searchString);
			}
			else {
				navigate('/filemanagement');
			}
			setIsLoading(false);
		})();
	}, []);

	if (isLoading) {
		// ロード中の場合はローディング画面
		return (
			<Loading />
		);
	} else {
		return (
			<div className="fileManagement">
				{/* プログレスバーを改善 */}
				{showProgress && (
					<div style={{
						position: 'fixed',
						top: 0,
						left: 0,
						width: '100%',
						height: '100%',
						backgroundColor: 'rgba(0, 0, 0, 0.5)',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						zIndex: 9999,
					}}>
						<div style={{
							background: 'white',
							padding: '30px',
							borderRadius: '8px',
							textAlign: 'center',
							boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
							minWidth: '350px',
						}}>
							<p style={{ margin: '0 0 20px 0', fontSize: '16px', color: '#333' }}>
								{/* 一括ダウンロードかどうかで表示を分ける */}
								{downloadList.length > 1 
									? `複数ファイルをダウンロード中です... (${downloadList.length}件)`
									: (progressValue < 70 ? 'サーバーからファイルを取得中...' : 'ファイルをダウンロード中...')
								}
							</p>
							<div style={{
								width: '100%',
								height: '20px',
								backgroundColor: '#f0f0f0',
								borderRadius: '10px',
								overflow: 'hidden',
								marginBottom: '10px',
							}}>
								<div style={{
									height: '100%',
									backgroundColor: downloadList.length > 1 ? '#4CAF50' : (progressValue < 70 ? '#ff9800' : '#3498db'),
									width: `${progressValue}%`,
									transition: 'width 0.3s ease, background-color 0.3s ease',
									borderRadius: '10px',
								}}></div>
							</div>
							<span style={{ fontSize: '14px', color: '#666' }}>
								{Math.round(progressValue)}%
							</span>
							<p style={{ margin: '10px 0 0 0', fontSize: '12px', color: '#999' }}>
								{downloadList.length > 1 
									? 'ファイル数が多い場合、お時間をいただく場合があります'
									: (progressValue < 70 ? 'ファイルサイズによってはお時間をいただく場合があります' : 'もうすぐ完了します')
								}
							</p>
						</div>
					</div>
				)}
				<Grid container spacing={2} className="filter">
					{/* <Grid item md={2} className="griditem"> */}
					<Grid item md={2} className="griditem">
						<Select
							name="service"
							label={t('service')}
							helperText={!formValues.service ? setMessage(t('message.1000200'), [t('service').toLowerCase()]) : ""}
							value={formValues.service}
							onChange={selectService}
							required
							error={!formValues.service}
							disabled={!serviceSelectorAuthFlg}
							fullWidth
							className="serviceSelector"
						>
							{serviceList.map((service, index) => {
								return <option key={index} value={service.auditCode}>{service.auditName}</option>;
							})}
						</Select>
					</Grid>
					<Grid item md={2} className="griditem">
						<Select
							name="org"
							label={t('org')}
							helperText={!formValues.org ? setMessage(t('message.1000200'), [t('org').toLowerCase()]) : ""}
							value={formValues.org}
							onChange={selectOrg}
							required
							error={!formValues.org}
							disabled={!orgSelectorAuthFlg || !formValues.service}
							fullWidth
							className="orgSelector"
						>
							{orgList.map((org, index) => {
								return <option key={index} value={org.orgLevel0Code}>{org.comp}</option>;
							})}
						</Select>
					</Grid>
					<Grid item md={3} className="griditem">
						<Select
							name="proj"
							label={t('proj')}
							helperText={!formValues.proj ? setMessage(t('message.1000200'), [t('proj').toLowerCase()]) : ""}
							value={formValues.proj}
							onChange={selectProj}
							required
							error={!formValues.proj}
							disabled={!projSelectorAuthFlg || !formValues.org}
							fullWidth
							className="projSelector"
						>
							{projList.map((proj, index) => {
								return <option key={index} value={proj.projCode}>{proj.projName}</option>;
							})}
						</Select>
					</Grid>
					<Grid item md={4} className="griditem">
						<DateRangePicker
							startLabel={t('uploadDate')}
							className="deliveryDateRange"
							endLabel="　"
							startProps={{ placeholder: 'From', error: formValues.startDateErrFlg }}
							endProps={{ placeholder: 'To', error: formValues.endDateErrFlg, helperText: formValues.endDateErrFlg ? t('message.1000400') : "" }}
							dateFormat='yyyy/MM/DD'
							helperText={formValues.startDateErrFlg ? t('message.1000400') : ""}
							onChange={selectDate}
							disabled={!deliveryDateRangeAuthFlg}
						/>
					</Grid>
				</Grid>
				<div className="buttons">
					<Button
						variant="primary"
						size="small"
						className="allDownloadBtn"
						status="success"
						onClick={handleAllDownloadClick}
						disabled={!formValues.org || !formValues.service || !formValues.proj}
					>
						{t('allDownload')}
					</Button>
					<Button
						variant="primary"
						size="small"
						className="uploadBtn"
						status="success"
						onClick={handleUploadClick}
						disabled={!formValues.org || !formValues.service || !formValues.proj || !uploadBtnAuthFlg}
					>
						<Plus />{t('upload')}
					</Button>
				</div>
				<div className='table-wrap'>
					<div className='overlayCheckbox'>
						<Checkbox
							checked={isAllCheckbox}
							onChange={handleAllCheck}
							indeterminate={indeterminate}
						/>
					</div>
					<Table
						className="downloadList"
						columns={filteredColumnsList}
						rowId="id"
						rows={fileManagementList}
						rowsPerPageOptions={[10, 50, 100, 'All']}
						rowProps={{ hover: false }}
						tablePaginationProps={{
							labelDisplayedRows: ({ from, to, count }) => `全${count}件`,
							truncate: true,
						}}
						emptyProps={{ text: t('message.1000100') }}
					/>
				</div>
				{dialogStatus === DIALOG_STATUS.OK_DIALOG && (
					<Dialog
						isOpen={dialogOpen}
						content={dialogContent}
						onOk={onOk}
					/>
				)}
				{dialogStatus === DIALOG_STATUS.DETAIL_DIALOG && (
					<DetailDialog
						isOpen={dialogOpen}
						content={dialogContent}
						detailContent={detailContent}
						onOk={onOk}
					/>
				)}
				{dialogStatus === DIALOG_STATUS.DELETE_CONFIRM_DIALOG && (
					<ConfirmDialog
						isOpen={confirmDialogOpen}
						content={confirmDialogContent}
						onOk={onDeleteConfirmOk}
						onCancel={onCancel}
					/>
				)}
			</div >
		);
	}
}

export default FileManagement;